import { render, staticRenderFns } from "./AddEshantion.vue?vue&type=template&id=35a1d37d&"
import script from "./AddEshantion.vue?vue&type=script&lang=js&"
export * from "./AddEshantion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports